import React, { useState, useEffect } from "react";
import axios from "axios";

const FilterSalesTarget = ({ setUserDetailResponse ,IsFilterSalesTarget,setIsFilterSalesTarget}) => {
  const baseAPI = process.env.REACT_APP_API_URL;

  const [GetMonth, setGetMonth] = useState([]);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}userGet/GetTargetForMonth`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setGetMonth(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetSalesTargetForAll?currentMonthYear=&months=${firstItem.target_for_month}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setUserDetailResponse(response.data.data);

          // Optionally, reset the form
          setFirstItem({
            target_for_month: "",
          });
          setIsFilterSalesTarget(!IsFilterSalesTarget);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const [firstItem, setFirstItem] = useState({
    target_for_month: "",

    createdBy: "Vishal",
    is_active: "true",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem({
      ...firstItem,
      [name]: value,
    });
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="SalesTargetDetail">
        <form className="SalesTarget-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Month</td>
            </tr>

            <tr>
              <td style={{ width: "10%" }}>
                <select
                  className="form-control"
                  name="target_for_month"
                  onChange={handleChange}
                  value={firstItem.target_for_month}
                >
                  <option value="0">Select an option</option>
                  {GetMonth.map((item) => (
                    <option
                      value={`${item.MonthName},${item.Year}`}
                      key={`${item.MonthName}-${item.Year}`}
                    >
                      {`${item.MonthName}, ${item.Year}`}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addSalesTarget-button">
            {/* <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button> */}
            <button
              type="submit"
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
              onClick={handleSubmit}
            >
              Search
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default FilterSalesTarget;
